import { messagesFrom } from './createSweepRuleForSenderService.locstring.json';
import loc, { format } from 'owa-localize';
import BulkTriageActionType from 'owa-service/lib/contract/BulkTriageActionType';
import CreateSweepRuleForSenderJsonRequest from 'owa-service/lib/contract/CreateSweepRuleForSenderJsonRequest';
import CreateSweepRuleForSenderRequest from 'owa-service/lib/contract/CreateSweepRuleForSenderRequest';
import CreateSweepRuleForSenderResponse from 'owa-service/lib/contract/CreateSweepRuleForSenderResponse';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import KeepNType from 'owa-service/lib/contract/KeepNType';
import createSweepRuleForSenderRequest from 'owa-service/lib/factory/createSweepRuleForSenderRequest';
import createSweepRuleForSenderOperation from 'owa-service/lib/operation/createSweepRuleForSenderOperation';
import { getJsonRequestHeader } from 'owa-service/lib/Utils';

/**
 * Helper function to create the empty rule names array which has the same length of the emailAddresses array.
 * This is a workaround for server validation and will be removed after fixing
 * VSO 8796: Improve validation for utah CreateSweepRuleForSenderAction
 */
function createRuleNames(emailAddresses: EmailAddressWrapper[]) {
    return emailAddresses.map(email => {
        return format(loc(messagesFrom), email.Name);
    });
}

/**
 * Create sweep rule for sender service request
 * @param emailAddresses the email addresses to be blocked
 * @return the ApplyBulkItemActionResponse
 */
export default function createSweepRuleForSenderService(
    emailAddresses: EmailAddressWrapper[],
    destinationFolderId: string,
    sourceFolderId: string,
    keepNType: KeepNType,
    keepNCount: number
): Promise<CreateSweepRuleForSenderResponse> {
    const requestBody = createSweepRuleForSenderRequest(<CreateSweepRuleForSenderRequest>{
        EmailAddresses: emailAddresses,
        ActionType: BulkTriageActionType.Move,
        RuleName: null /* deprecated required param*/,
        RuleNames: createRuleNames(emailAddresses),
        SourceFolderId: { Id: sourceFolderId },
        DestinationFolderId: { Id: destinationFolderId },
        CountType: keepNType,
        KeepNCount: keepNCount,
    });

    return createSweepRuleForSenderOperation(<CreateSweepRuleForSenderJsonRequest>{
        Header: getJsonRequestHeader(),
        Body: requestBody,
    }).then(response => {
        return response.Body;
    });
}
